import React, {useCallback, useState} from 'react';
import './FormikInputComponent.scss';
import InputComponent from "../input/InputComponent";
import _ from "lodash";
import {FieldProps} from "formik";
import TooltipComponent from "../../tooltip/tooltipComponent";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";

export interface FormikInputComponentProps {
    readOnly?: boolean;
    label?: string;
    placeholder: string;
    type?:
        | 'email'
        | 'number'
        | 'password'
        | 'tel'
        | 'text'
        | 'url';
    id?: string;
    onUpdate?: any;
    required?: boolean;
    toggleShowPassword?: boolean;
    disabled?: boolean;
    multiline?: boolean
    variant?: "filled" | "standard" | "outlined" | undefined;
    color?: "error" | "primary" | "secondary" | "info" | "success" | "warning" | undefined;
    size?: "small" | "medium" | undefined;
    onChange?: (text: string) => void;
    fullWidth?: boolean;
    trimLeft?: boolean;
    formikField: FieldProps;
    rows?:number;
    maxLength?:number;
    prefix?: any;
    suffix?: any;
}

const FormikInputComponent = (props: FormikInputComponentProps) => {
    const {
        label,
        required,
        placeholder,
        color,
        readOnly,
        multiline,
        id,
        onUpdate,
        variant,
        formikField,
        size,
        type,
        fullWidth,
        toggleShowPassword,
        rows,
        disabled,
    } = props;

    const {field, form} = formikField;
    const {name, value} = field;
    const {setFieldTouched, touched, handleBlur,validateField, errors, setFieldValue} = form;

    const [showPassword, setShowPassword] = useState<boolean>(false);

    const hasError = _.get(touched, name) && !!(_.get(errors, name));
    const trimLeft = props.trimLeft === undefined ? true : props.trimLeft;

    const textChangeHandler = useCallback((text: string) => {
        if (trimLeft) {
            text = text?.toString().trimStart();
        }
        (async () => {
            await setFieldValue(name, text);
            await setFieldTouched(name);
            await validateField(name);
        })()
        if (onUpdate) {
            onUpdate(text);
        }
    }, [setFieldValue, setFieldTouched, name, onUpdate, trimLeft,validateField]);

    const onInputBlur = useCallback(() => {
        handleBlur(name);
        setFieldTouched(name);
    }, [name, handleBlur, setFieldTouched]);

    const onInputFocus = useCallback(() => {
    }, []);

    const handlePasswordToggle = useCallback(() => {
        setShowPassword(!showPassword);
    }, [showPassword]);

    return (
        <InputComponent
            name={name}
            label={label}
            value={value}
            placeholder={placeholder}
            id={id}
            size={size}
            required={required}
            variant={variant}
            multiline={multiline}
            fullWidth={fullWidth}
            color={color}
            suffix={type === 'password' ? (toggleShowPassword
                && <TooltipComponent
                    tooltip={
                        !showPassword ? "Show Password" : "Hide Password"
                    }
                >
                <span
                    onClick={handlePasswordToggle}
                    className={"input-suffix-password-toggle"}
                >
                {showPassword ? <VisibilityOff/> : <Visibility/>}
                </span>
                </TooltipComponent>):props.suffix
            }
            readOnly = {readOnly}
            maxLength={props.maxLength}
            toggleShowPassword={toggleShowPassword}
            inputProps={{
                onBlur: onInputBlur,
                onFocus: onInputFocus,
                maxLength: props.maxLength,
            }}
            prefix={props.prefix}
            disabled={disabled}
            rows={rows}
            hasError={hasError}
            errorMessage={hasError && (_.get(errors, name))}
            type={(type === 'password' && toggleShowPassword && showPassword) ? "text" : type}
            onChange={textChangeHandler}
        />
    );
};

export default FormikInputComponent;
